"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkboxes = Checkboxes;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _useFormInputFetch = _interopRequireDefault(require("../shared/stateFunctions/useFormInputFetch"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function Checkboxes(props) {
  var label = props.label,
      _props$initialValue = props.initialValue,
      initialValue = _props$initialValue === void 0 ? "" : _props$initialValue,
      cbSuccess = props.cbSuccess;
  var input = (0, _useFormInputFetch.default)(initialValue, props.uid, props.name, props);
  var options = props.options || [];

  var selectOption = function selectOption(optionValue) {
    if (!input.isEdit) {
      input.setIsEdit(true);
    }

    var tmpVal = _objectSpread({}, input.value);

    if (tmpVal[optionValue]) {
      delete tmpVal[optionValue];
    } else {
      tmpVal[optionValue] = true;
    }

    input.setValue(tmpVal);
  };

  var inputField = _react.default.createElement("div", null, options.map(function (option) {
    return _react.default.createElement("div", {
      class: "form-check",
      onClick: function onClick() {
        return selectOption(option.value);
      }
    }, _react.default.createElement("input", {
      class: "form-check-input",
      type: "checkbox",
      checked: input.value[option.value]
    }), _react.default.createElement("label", {
      class: "form-check-label"
    }, option.label));
  }), _react.default.createElement("div", {
    className: "mt-1 mb-2"
  }, _react.default.createElement("small", {
    style: {
      color: "gray"
    }
  }, props.helperText)), input.isEdit && _react.default.createElement("div", null, _react.default.createElement("button", {
    class: "btn btn-outline-primary",
    type: "button",
    onClick: function onClick() {
      return input.save();
    }
  }, "Save"), _react.default.createElement("button", {
    class: "btn btn-outline-secondary ml-2",
    type: "button",
    onClick: input.cancelEdit
  }, "Cancel")));

  if (props.isCol) {
    return _react.default.createElement("div", null, _react.default.createElement("label", null, label), inputField);
  }

  return _react.default.createElement("div", {
    className: "row m-0"
  }, _react.default.createElement("div", {
    className: "col-3"
  }, label), _react.default.createElement("div", {
    className: "col-6"
  }, inputField));
}

var _default = Checkboxes;
exports.default = _default;